import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TapeChartComponent } from '../tape-chart/tape-chart.component';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlertService } from '@app/_services';
import { DatePipe } from '@angular/common';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { TapeChartService } from '../tape-chart.service';
import { TapeChart } from '../tape-chart';
import { ReservationsComponent } from '../../reservation/reservation/reservation.component';

@Component({
    selector: 'app-tape-chart-list',
    templateUrl: './tape-chart-list.component.html',
    styleUrls: ['./tape-chart-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class TapeChartListComponent implements OnInit {
	constructor(
		private tapeChartService: TapeChartService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
		private datePipe: DatePipe
	) {
		this.statuses = tapeChartService.statuses;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	@Input() showSearchUI = true;
	@Input() titleFontSize = false;
	@Input() propertyId: any;
	@Input() startDate: any;
	@Input() endDate: any;
	@Output() doRedirectBulkUpdateCB = new EventEmitter<any>();
	tapeCharts: any[] = [];
	tapeChart: TapeChart;
	calculatedYieldPrice: any;

	tapeChartsByProperty: any[] = [];

	scrollingColumns: any[] = [];
  	frozenColumns: any[] = [];
	frozenWidth: string = '400px';

	// to hold the current search
	currentSearchForm: any;

	 // window
	 innerWidth;
	 innerHeight;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = false;
	multiSortMeta = [];

	statuses: any;

	columns: any[] = [
		{ field: 'propertyCode', header: 'Property', width: 'auto' },
		{ field: 'analyzedDate', header: 'Date', width: 'auto' },
		{ field: 'listPriceAMT', header: 'List Price', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'analyzedDate', order: 0 });
			this.setInnerWidthHeightParameters();
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.rateId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-tapeChart-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'analyzedDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.tapeChartService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.tapeCharts = res.data.rates;
						// this.buildColumns();
						this.buildRows();
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.tapeCharts = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	buildColumns(searchForm) {
		this.scrollingColumns = [];
		this.frozenColumns = [];
	
		this.frozenColumns = [
		  { field: 'propertyCode', header: 'Property' }
		];

		for(var d = this.addTimeOffsetToLocalDateTime(new Date(searchForm.startDate)); d <= this.addTimeOffsetToLocalDateTime(new Date(searchForm.endDate));d.setDate(d.getDate() + 1))
		{
			let startYear = d.getFullYear();
			let startMonth = d.getMonth();
			let startDate = d.getDate();
			let updatedStartMonth = ""+startMonth;
			if(startMonth < 9)
			{
				updatedStartMonth = "0" + (startMonth+1);
			}
			else
			{
				updatedStartMonth = "" + (startMonth+1);
			}
			let updatedStartDate = ""+startDate;
			if(startDate <= 9)
			{
				updatedStartDate = "0" + startDate;
			}
			let updatedFullDate = startYear + "-" + updatedStartMonth + "-" + updatedStartDate;
			
			this.scrollingColumns.push({
				field: updatedFullDate, header: new DatePipe('en-US').transform(d, 'MM-dd-yy EEE')
			  });
		}
	
		// unfrozen scrollingColumns - use the first property returned
		// for (let index = 0; index < this.tapeCharts?.length; index++)
		// {
		//   this.scrollingColumns.push({
		// 	field: this.tapeCharts[index].analyzedDate, header: new DatePipe('en-US').transform(this.tapeCharts[index].analyzedDate, 'MM-dd-yy')
		//   });
		// }
	}

	buildRows() {
		console.log("Building rows");
		this.tapeChartsByProperty = [];
		//Group all by property code
		let map = new Map();
		for (let index = 0; index < this.tapeCharts?.length; index++)
		{
			if(map.get(this.tapeCharts[index].propertyCode)) {
				let tapeChartRowsByProperty = map.get(this.tapeCharts[index].propertyCode);
				tapeChartRowsByProperty.push(this.tapeCharts[index]);
				map.set(this.tapeCharts[index].propertyCode, tapeChartRowsByProperty);
			} else {
				let tapeChartRowsByProperty = [];
				tapeChartRowsByProperty.push(this.tapeCharts[index]);
				map.set(this.tapeCharts[index].propertyCode, tapeChartRowsByProperty);
			}
		}
		map.forEach((value: string, key: string) => {
			let property = {
				propertyCode: key,
				rates: value
			}
			this.tapeChartsByProperty.push(property)
		});
		console.log("Building rows finished");
		this.tapeChartsByProperty.forEach(property => {
			this.scrollingColumns.forEach(column => {
				this.matchHeaderDate(property, column.field);
			});
		});
	}

	matchHeaderDate(rowData, analyzedDate) {
		console.log("Matching header Dates for " + rowData.propertyCode + " Date " + analyzedDate);
		let record: any = {};
		record.isDateMatched = false;
		rowData.rates.forEach(element => {
			if(!record.isDateMatched && element.analyzedDate == analyzedDate) {
				record = element
				record.isDateMatched = true;
				console.info("Header Dates matched");
				return;
			}
		});
		// return record;
	}

	onSearchSubmit(searchForm: any) {
		this.currentSearchForm = searchForm;
		this.getTapeChartDetails(searchForm);
	}

	getTapeChartDetails(searchForm)
  	{
	  try
	  {
	  this.loading = true;
	  searchForm.startDate = this.addLocalTimeToDateTime(new Date(searchForm.startDate)); 
	  searchForm.endDate = this.addLocalTimeToDateTime(new Date(searchForm.endDate)); 
	  if(this.propertyId) {
		searchForm.yielMaxPropertyIdList = [this.propertyId];
	  }
	  this.tapeChartService.searchRateSummaries(searchForm)
		.subscribe(
		res =>
		{
			// console.log('searchRateSummaries SUCCESS: ' + JSON.stringify(res.data.rateSummary));
			this.tapeCharts = res.data.rates;
			this.buildColumns(searchForm);
			this.buildRows();
			this.loading = false; 
			// this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message, life: 3000 });
		},
		err =>
		{
			console.log('searchRateSummaries FAIL: ' + JSON.stringify(err));
			this.messageService.add({ severity: 'error', summary: 'Error', detail: err });
		},
		() => { this.loading = false; });

	} catch (error)
	{
		this.loading = false;
		this.alertService.error(error);
	}
  }

  getTapeChartDetailsByRateId(rateId)
  	{
	  try
	  {
	  this.loading = true;
	  this.tapeChartService.searchRateSummariesByRateId(rateId)
		.subscribe(
		res =>
		{
			// console.log('searchRateSummaries SUCCESS: ' + JSON.stringify(res.data.rateSummary));
			let tapeChart = res.data.rate;
			this.loading = false; 
			this.onOpenFormEdit(tapeChart);
		},
		err =>
		{
			console.log('getTapeChartDetailsByRateId FAIL: ' + JSON.stringify(err));
			this.messageService.add({ severity: 'error', summary: 'Error', detail: err });
		},
		() => { this.loading = false; });

	} catch (error)
	{
		this.loading = false;
		this.alertService.error(error);
	}
  }

  generateRates()
  {
	try
	  {
	  this.loading = true;
	  this.tapeChartService.generateRates()
		.subscribe(
		res =>
		{
			this.loading = false; 
		},
		err =>
		{
			console.log('generateRates FAIL: ' + JSON.stringify(err));
			this.messageService.add({ severity: 'error', summary: 'Error', detail: err });
		},
		() => { this.loading = false; });

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Rates are being generated, please check back shortly for results.', life: 3000 });
		this.loading = false; 

	} catch (error)
	{
		this.loading = false;
		this.alertService.error(error);
	}
  }

	setInnerWidthHeightParameters()
	{
		this.innerWidth = window.innerWidth;
		this.innerHeight = window.innerHeight * 0.70;
		if (this.innerWidth < 768) { this.frozenWidth = '100px'; }
		else if (this.innerWidth < 992) { this.frozenWidth = '150px'; }
		else { this.frozenWidth = '400px'; }
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.getTapeChartDetailsByRateId(event?.data?.rateId)
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(tapeChart: TapeChart) {
		try {
			this.loading = true;
			this.tapeChartService.update(tapeChart)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.tapeCharts.map((tapeChart, i) => {
							if (tapeChart.rateId === res.data.tapeChart.rateId) {
								this.tapeCharts[i] = res.data.tapeChart;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.loading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(tapeChart: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(tapeChart));

			this.loading = true;
			this.tapeChartService.delete(tapeChart.rateId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.tapeCharts.splice(this.tapeCharts.indexOf(tapeChart), 1);
						this.recordTotal = this.tapeCharts.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'TapeChart ' + tapeChart.rateId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'TapeChart ' + tapeChart.rateId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.loading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add TapeChart'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(TapeChartComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addTapeChartCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(tapeChart: any) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			tapeChart: tapeChart,
			title: 'Edit ',
			analyzedDate: tapeChart.analyzedDate
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(TapeChartComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateTapeChartCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteTapeChartCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addTapeChartCB(tapeChart: TapeChart) {
		console.log('Adding TapeChart: ' + JSON.stringify(tapeChart));
		// if we don't have a tapeCharts array yet...
		if (!this.tapeCharts) {
			this.tapeCharts = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.tapeCharts.unshift(tapeChart);

		// no idea what this is but it is required to update the array
		this.tapeCharts = [...this.tapeCharts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'TapeChart ' + tapeChart.rateId + ' Added', life: 3000 });
	}

	updateTapeChartCB(tapeChart: TapeChart) {
		console.log('Updating TapeChart: ' + JSON.stringify(tapeChart));
		let itemIndex = this.tapeCharts.findIndex((item: any) => item.rateId === tapeChart.rateId);
		this.tapeCharts[itemIndex] = tapeChart;

		// no idea what this is but it is required to update the array
		this.tapeCharts = [...this.tapeCharts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'TapeChart ' + tapeChart.rateId + ' Updated', life: 3000 });
	}

	deleteTapeChartCB(tapeChart: TapeChart) {
		console.log('Removing TapeChart: ' + tapeChart);
		this.tapeCharts.splice(this.tapeCharts.indexOf(tapeChart), 1);
		this.recordTotal = this.tapeCharts.length;

		// no idea what this is but it is required to update the array
		this.tapeCharts = [...this.tapeCharts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'TapeChart ' + tapeChart.rateId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.tapeCharts ? this.first === (this.tapeCharts.length - this.rows) : true; }
	isFirstPage(): boolean { return this.tapeCharts ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(tapeChart: any) {
		if (tapeChart?.status) {
			const status = this.statuses.find((e: any) => e.value == tapeChart.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	//Redirect to bulk update component and pass selected rate object to show default selected values
	onGoToBulkUpdate(rate: any) {
		this.doRedirectBulkUpdateCB.emit(rate);
	}

	showPaginator()
	{
		return true;
	}

	editRateDetails(rate) {
		//Open only if not reserved as we are showing reservation details page for reserved day
		if(!rate.reservationId)
		{
			this.getTapeChartDetailsByRateId(rate.rateId)
			// this.onOpenFormEdit(rate);
		}
	}

calcMinListPrice(advertisedRate: any)
  {

    let response: any = {};
    let systemFloorRate = [];

    /*
    Calc the lowest allowed rate, if any set by manager, owner, or global
    */

    // calc lowest by Manager
    systemFloorRate.push(advertisedRate.floorRateManagerAMT ? advertisedRate.floorRateManagerAMT : 0);

    // calc lowest by Owner
    systemFloorRate.push(advertisedRate.floorRateOwnerAMT ? advertisedRate.floorRateOwnerAMT : 0);

    // calc lowest by global minNightly
    systemFloorRate.push(advertisedRate.minNightlyRate ? advertisedRate.minNightlyRate : 0);

    // calc lowest by rack or discounter
    let minAdRate = (this.calcPropertyListPrice(advertisedRate) -
      (+this.calcPropertyListPrice(advertisedRate) * (advertisedRate.maxDiscountPCT ? advertisedRate.maxDiscountPCT : 0)));


    let minSystemRate = Math.max(...systemFloorRate);


    // if we have a artificially high floor,
    if (minSystemRate > minAdRate)
    {
      response.rate = minSystemRate;
      response.color = '#FFA500';
    }
    else
    {
      response.rate = minSystemRate;
      response.color = 'transparent';
    }

    return response;

  }

  openReservation(rate: any)
  {
	const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "40vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			reservation: rate,
			title: 'Edit Reservation',
			isFromTapeChart: true
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ReservationsComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.updateReservationCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.deleteReservationCB(data);

				// close the dialogBox
				dialogRef.close();
			});
  }

  calcPropertyListPrice(advertisedRate: any)
  {
    if (advertisedRate && advertisedRate.listPriceAdjustAMT)
    {
      return +this.formatPercent(advertisedRate.listPriceAdjustAMT);
    }
    else
    {
      return this.calcListPrice(advertisedRate);
    }
  }

//   calcPropertyListPrice(advertisedRate: any)
//   {
//     if (advertisedRate && advertisedRate.rateBucketAdjustmentPct)
//     {
//       return this.calcListPrice(advertisedRate) + (this.calcListPrice(advertisedRate) * advertisedRate.rateBucketAdjustmentPct)
//     }
//     else
//     {
//       return this.calcListPrice(advertisedRate);
//     }
//   }

  calcListPrice(advertisedRate: any)
  {
    if (advertisedRate && advertisedRate.listPriceAMT)
    {
      return +this.formatPercent(advertisedRate.listPriceAMT);
    }
  }

  calcYielPrice(advertisedRate: any)
  {
    if (advertisedRate && advertisedRate.yieldPriceAMT)
    {
      return +this.formatPercent(advertisedRate.yieldPriceAMT);
    }
  }

  calcAmtFromListPriceAdjustPCT(advertisedRate: any)
  {
    if (advertisedRate && advertisedRate.listPriceAdjustPCT)
    {
		let propertyListPrice = +this.calcPropertyListPrice(advertisedRate);
		return propertyListPrice + (propertyListPrice * advertisedRate.listPriceAdjustPCT)
    }
  }

  calcAmtFromRateBucketAdjustmentPct(advertisedRate: any)
  {
    if (advertisedRate && advertisedRate.rateBucketAdjustmentPct)
    {
		let propertyListPrice = +this.calcAmtFromListPriceAdjustPCT(advertisedRate);
		if(!propertyListPrice)
		{
			propertyListPrice = +this.calcPropertyListPrice(advertisedRate);
		}
		return propertyListPrice + (propertyListPrice * advertisedRate.rateBucketAdjustmentPct)
    }
  }

  calcAmtFromMaxDiscountPCT(advertisedRate: any)
  {
    if (advertisedRate && advertisedRate.maxDiscountPCT)
    {
		let maxFloorAmount : number = advertisedRate.listPriceAMT;
		if (advertisedRate && advertisedRate.listPriceAdjustAMT)
		{
			maxFloorAmount = advertisedRate.listPriceAdjustAMT;
		}
		if (advertisedRate && advertisedRate.listPriceAdjustPCT)
		{
			maxFloorAmount = maxFloorAmount + (maxFloorAmount * advertisedRate.listPriceAdjustPCT)
		}
		if (advertisedRate && advertisedRate.rateBucketAdjustmentPct)
		{
			maxFloorAmount = maxFloorAmount + (maxFloorAmount * advertisedRate.rateBucketAdjustmentPct)
		}
		if(advertisedRate.floorRateOwnerAMT > maxFloorAmount)
		{
			return advertisedRate.floorRateOwnerAMT + (advertisedRate.floorRateOwnerAMT * advertisedRate.maxDiscountPCT)
		}
		else if(advertisedRate.minNightlyRate > maxFloorAmount)
		{
			return advertisedRate.minNightlyRate + (advertisedRate.minNightlyRate * advertisedRate.maxDiscountPCT)
		}
		else if(advertisedRate.floorRateManagerAMT > maxFloorAmount)
		{
			return advertisedRate.floorRateManagerAMT + (advertisedRate.floorRateManagerAMT * advertisedRate.maxDiscountPCT)
		}
		else 
		{
			return maxFloorAmount + (maxFloorAmount * advertisedRate.maxDiscountPCT)
		}
    }
  }

  calcListPriceAdjPct(advertisedRate: any)
  {
    if (advertisedRate && advertisedRate.listPriceAdjustPCT)
    {
      let propertyListPrice = +this.calcPropertyListPrice(advertisedRate);
      return propertyListPrice + (propertyListPrice * advertisedRate.listPriceAdjustPCT)
    }
  }

  formatPercent(numPercent: string)
  {
    return parseFloat(numPercent).toFixed(2);
  }

  calcYMDiscFloorPrice(advertisedRate: any)
  {
    // if we have a discounting algorithm
    if (advertisedRate && advertisedRate.discountLookForwardDays && advertisedRate.discountLookForwardDays > 0 && advertisedRate.maxDiscountPCT && advertisedRate.maxDiscountPCT > 0)
    {
      let floor = 0.00;

      // calculate the lowest by the yield manager
      floor = +this.calcPropertyListPrice(advertisedRate) - (+this.calcPropertyListPrice(advertisedRate) * advertisedRate.maxDiscountPCT);

      if (advertisedRate.floorRateManagerAMT && advertisedRate.floorRateManagerAMT > 0)
      {
        if (floor > advertisedRate.floorRateManagerAMT)
        {
          return floor;
        }
        else
        {
          return advertisedRate.floorRateManagerAMT
        }
      }
      else if (advertisedRate.floorRateOwnerAMT && advertisedRate.floorRateOwnerAMT > 0)
      {
        if (floor > advertisedRate.floorRateOwnerAMT)
        {
          return floor;
        }
        else
        {
          return advertisedRate.floorRateOwnerAMT
        }
      }
      else
      {
        return floor;
      }
    }
    else
    {
      return +this.calcPropertyListPrice(advertisedRate);
    }
  }

  calcDaysBookedBeforeCheckin(rate) {
		let saleDate = new Date(rate.saleDate);
		let checkInDateTime = new Date(rate.checkInDateTime);
		let days = Math.floor((Date.UTC(checkInDateTime.getFullYear(), checkInDateTime.getMonth(), checkInDateTime.getDate()) - Date.UTC(saleDate.getFullYear(), saleDate.getMonth(), saleDate.getDate()) ) /(1000 * 60 * 60 * 24));
    	return days;
  }

	/**
	 * Add time plus local time GMT hours as http request change time to UTC time
	 * @param datetime 
	 * @returns 
	 */
	addLocalTimeToDateTime(datetime) {
		console.log(datetime.getTime());
		console.log(datetime.getTimezoneOffset());
		return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
	}

	/**
	 * new Date('String Date') creates date with timezone offset hence this method add timezone hours
	 * @param datetime 
	 * @returns 
	 */
	addTimeOffsetToLocalDateTime(datetime) {
		let offsetMin = datetime.getTimezoneOffset();
		// If positive means timezone is in minus of UTC
		if(offsetMin > 0)
		{
			return new Date(datetime.getTime() + (datetime.getTimezoneOffset() * 60000));
		}
		else
		{
			return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
		}
	}
}
